import NewLandingView from './View';

export default NewLandingView;